<template>
    <div class="kpi">
        <div class="kpi-bar" :class="accent"></div>
        <div class="label">{{ label }}</div>
        <div class="value">{{ value }}</div>
    </div>
</template>

<script>
export default {
    props: {
        label: String,
        value: [String, Number],
        accent: { type: String, default: 'ocean' }
    }
}
</script>

<style lang="scss" scoped>
.kpi {
    background: var(--surface);
    border: 1px solid var(--line);
    border-radius: var(--radius);
    padding: 1.1rem 1.2rem;
    box-shadow: var(--shadow);
    position: relative;
    overflow: hidden;
}

.label {
    font-size: .72rem;
    font-weight: 600;
    color: var(--ink-faint);
    text-transform: uppercase;
    letter-spacing: .05em;
}

.value {
    font-family: 'IBM Plex Mono', monospace;
    font-weight: 600;
    letter-spacing: -0.01em;
    font-size: 1.65rem;
    margin-top: .4rem;
}

.delta {
    font-size: .75rem;
    font-weight: 600;
    margin-top: .3rem;

    &.up {
        color: var(--moss);
    }

    &.down {
        color: var(--coral);
    }

    &.flat {
        color: var(--ink-faint);
    }
}

.kpi-bar {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;

    &.ocean {
        background: var(--ocean);
    }

    &.amber {
        background: var(--amber);
    }

    &.moss {
        background: var(--moss);
    }

    &.coral {
        background: var(--coral);
    }

    &.ink {
        background: var(--ink);
    }
}
</style>


// WEBPACK FOOTER //
// kpiCard.vue?04496b30